import Axes from '../../sceneWrapper/types/Axes';

/** The previous position of the pointer. */
const pointerPosPrevious: Pick<Axes, 'x' | 'y'> = {
    x: 0,
    y: 0
};

export default pointerPosPrevious;
